import { DEFAULT_CONFIG } from './defaults';
import type { ClickReleaseConfig, ConfigOverride } from './types';

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

/** Deep-merge `override` onto `base`, returning a new object. Scalars/arrays from override win. */
function deepMerge<T>(base: T, override: unknown): T {
  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override === undefined ? base : (override as T);
  }
  const out: Record<string, unknown> = { ...base };
  for (const key of Object.keys(override)) {
    const next = override[key];
    if (next === undefined) continue;
    const prev = out[key];
    out[key] = isPlainObject(prev) && isPlainObject(next) ? deepMerge(prev, next) : next;
  }
  return out as T;
}

/**
 * Resolve the effective config. Precedence (low → high): bundled defaults ← client override
 * (supplied by the embedding client via `init({ config })`). See DESIGN.md.
 */
export function resolveConfig(override?: ConfigOverride | null): ClickReleaseConfig {
  const base = structuredClone(DEFAULT_CONFIG);
  return override ? deepMerge(base, override) : base;
}
